import React from 'react';
import { v4 } from 'uuid';
import { UseOpenWorkspacePanelWorkspaceConfig } from '../panels/use-open-workspace-panel';
import { useIntegratedActionBroadcaster } from '../action-broadcaster/use-integrated-action-broadcaster';
import { AttachmentsPanelType, AttachmentSortOptionValue } from './types';

export type OpenAttachmentsPanelArgs = {
    entityId?: number;
    entityType: AttachmentsPanelType;
    shouldFocus?: boolean;
    attachmentId?: number;
    sortOption?: AttachmentSortOptionValue;
    isClearedEvent?: boolean;
    workspacePanelConfig?: Omit<
        UseOpenWorkspacePanelWorkspaceConfig<'MEDIA_ATTACHMENTS'>,
        'workspacePanelType'
    >;
};

export function useOpenAttachmentsPanel(): (args: OpenAttachmentsPanelArgs) => void {
    const { trigger } = useIntegratedActionBroadcaster();

    return React.useCallback(
        (args: OpenAttachmentsPanelArgs) => {
            trigger([
                {
                    id: v4(),
                    targetWindowType: 'ROOT',
                    type: 'OPEN_EVENT_V2_WINDOW',
                },
                {
                    id: v4(),
                    targetWindowType: 'EVENT_V2',
                    type: 'OPEN_ATTACHMENTS_PANEL',
                    payload: args,
                },
            ]);
        },
        [trigger]
    );
}
